// Enums
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';

// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.successContainer.';

const TITLES = {
    [AppStatesEnumeration.CHECKOUT_DOWNPAYMENT_PROCESSING]: `${DOMAIN}pendingTitle`,
    [AppStatesEnumeration.CHECKOUT_SIGNED_PENDING]: `${DOMAIN}pendingTitle`,
    [AppStatesEnumeration.CHECKOUT_SIGNED]: `${DOMAIN}title`,
    [AppStatesEnumeration.SUCCESS]: `${DOMAIN}title`,
  },
  DESCRIPTIONS = {
    [AppStatesEnumeration.CHECKOUT_DOWNPAYMENT_PROCESSING]: `${DOMAIN}pendingDescription`,
    [AppStatesEnumeration.CHECKOUT_SIGNED_PENDING]: `${DOMAIN}pendingDescription`,
    [AppStatesEnumeration.CHECKOUT_SIGNED]: `${DOMAIN}description`,
    [AppStatesEnumeration.SUCCESS]: `${DOMAIN}description`,
  },
  SUBTITLES = {
    [AppStatesEnumeration.CHECKOUT_DOWNPAYMENT_PROCESSING]: `${DOMAIN}pendingSubtitle`,
    [AppStatesEnumeration.CHECKOUT_SIGNED_PENDING]: `${DOMAIN}pendingSubtitle`,
    [AppStatesEnumeration.CHECKOUT_SIGNED]: `${DOMAIN}manageInstallmentsSubtitle`,
    [AppStatesEnumeration.SUCCESS]: `${DOMAIN}manageInstallmentsSubtitle`,
  },
  BUTTON = `${DOMAIN}goToAmazonButton`;

const DEFAULTS = {
  TITLE: TITLES[AppStatesEnumeration.CHECKOUT_SIGNED],
  DESCRIPTION: DESCRIPTIONS[AppStatesEnumeration.CHECKOUT_SIGNED],
  SUBTITLE: SUBTITLES[AppStatesEnumeration.CHECKOUT_SIGNED],
};

export { BUTTON, DEFAULTS, DESCRIPTIONS, SUBTITLES, TITLES };
